import React from "react";
import LandingPage from "./landing-page";

class LandingPageController extends React.Component{
//this.props.modalShowToggle("Alert", true, this.closeModal.bind(this, this), this.props.getValue(this.props.notificationInModal.title), this.props.getValue(this.props.notificationInModal.message))
    closeModal = () => {
        this.props.setIsDemoSuccess(false);
        this.props.setIsShowDemo(false);
    }

    showModal = () => {
        this.props.modalShowToggle("ForgotPassword", true)
    }

    componentDidMount(){
        if(this.props.activePage){
            this.props.setMenuActive(this.props.activePage);
        }
    }

    componentDidUpdate(){
        if(this.props.isShowDemo){
            this.props.modalShowToggle('getDemo', true, this.closeModal, this.props.getValue("GET_DEMO_ACCESS"), this.props.getValue("GET_DEMO_ACCESS"));
            return true
        }
        return true;
    }

    render(){
        return (
            <LandingPage {...this.props} showModal={this.showModal}/>
        )
    }
}

export default LandingPageController;